import ReactDOM from 'react-dom/client'
import App from './App'
import { installAuthFetchInterceptor } from './lib/api'
import { CUI_BANNER } from './components/ui/CuiBanner'
import './index.css'
import 'leaflet/dist/leaflet.css'

// Recover from an expired access token on any API call, not just the few that
// go through apiClient. Must run before the app issues its first request.
installAuthFetchInterceptor()

// Make room for the CUI banners before the first paint.
if (CUI_BANNER) document.documentElement.classList.add('cui-banner')

// Apply theme from localStorage immediately to prevent flash
const storedTheme = localStorage.getItem('theme')
if (storedTheme === 'dark') {
  document.documentElement.classList.add('dark')
} else if (storedTheme === 'light') {
  document.documentElement.classList.remove('dark')
} else {
  // Default to system preference if no stored theme
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
  if (prefersDark) {
    document.documentElement.classList.add('dark')
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <App />
)
